<template>
  <div
    :class="{
      home: true,
      'home-windows':
        this.$store.state.client == 'windows' ||
        this.$store.state.client == 'mac'
          ? true
          : false,
    }"
    @mouseup="onHeaderMouseUp"
    @mousemove="onHeaderGrabbing"
  >
    <div class="header" @mousedown="onHeaderMouseDown">
      <div
        :class="{
          logo: true,
          'logo-windows':
            (this.$store.state.client == 'windows' ||
              this.$store.state.client == 'mac') &&
            !isGrabbing
              ? true
              : false,
          'logo-mac': this.$store.state.client == 'mac',
        }"
      >
        <img
          class="logo-bd"
          src="../assets/home/logo.svg"
          alt="节点小宝"
          title="节点小宝"
          @click="onLogoClick"
        />
        <span class="slogan" title="为远程赋能" @click="onSloganClick"
          >为远程赋能</span
        >
      </div>
      <template v-if="this.$store.state.client == 'windows'">
        <img
          src="../assets/home/close.png"
          class="close-icon"
          title="关闭"
          @click="closeClientClick"
        />
        <img
          src="../assets/home/hide.png"
          class="hide-icon"
          title="最小化"
          @click="hideClientClick"
        />
      </template>
      <div class="menu" @click="showMenu"></div>
      <div class="menu_line"></div>
      <div
        class="xbyz"
        title="小宝驿站"
        @click="goXbyz"
        v-if="
          !$store.getters.isAppstoreMode &&
          $store.state.curDev &&
          pidInfo.cid != 123 &&
          pidInfo.cid != 99
        "
      ></div>
      <div class="unlogin" @click="showLogin" v-if="!$store.state.user.uid">
        <img class="unlogin-icon" src="../assets/home/unlogin-icon.png" />
        <img class="unlogin-tips" src="../assets/home/unlogin-tips.svg" />
      </div>
      <div class="user" @click="goUserInfoClick" v-else>
        <div
          class="vip-icon"
          v-if="
            $store.state.user.vip_left > 0 && !$store.getters.isAppstoreMode
          "
        >
          <img src="../assets/home/vip_icon.svg" />
        </div>
        <div class="free-icon" v-else-if="!$store.getters.isAppstoreMode">
          <div>免费会员</div>
        </div>
        <img class="user_icon" :src="this.$store.state.user.avatar" />
        <div class="user_info">
          <div class="username">
            {{ this.$store.state.user.name }}
          </div>
          <div class="uid">ID:{{ this.$store.state.user.uid }}</div>
        </div>
      </div>
    </div>
    <div class="content">
      <NavV4 ref="nav" v-show="isShowNav"></NavV4>
      <!-- <template
        v-if="
          ($store.state.bind_list && $store.state.bind_list.length > 0) ||
          !$store.state.user.uid
        "
      > -->
      <div class="main" :class="{ 'main-nav': isShowNav }">
        <keep-alive>
          <router-view v-slot="{ Component }">
            <!--        <transition name="move" mode="out-in">-->
            <component :is="Component" />
            <!--        </transition>-->
          </router-view>
        </keep-alive>
      </div>
      <!-- </template>
      <NoBind v-else></NoBind> -->
    </div>
    <Setting v-if="$store.state.isShowDeviceInfo"></Setting>
    <Menu v-if="isShowMenu" @hideMenu="hideMenu"></Menu>
    <PayExchange
      @onCloseClick="hidePayExchange"
      v-if="$store.state.isShowPayExchange"
    ></PayExchange>
    <AddDevice
      v-if="$store.state.isShowAddDevice"
      @closeAddDeviceClick="closeAddDeviceClick"
      @getBindget="getBindget"
      :deviceLength="$store.state.bind_list ? $store.state.bind_list.length : 0"
    ></AddDevice>
    <Bind
      :name="
        newPidInfo.name ? newPidInfo.name : newPidInfo.cname + newPidInfo.dname
      "
      :failed_tips="bindFailedTips"
      @onCancelClick="hideBindCheck"
      @onSureClick="doBind"
      v-if="isShowBindCheck"
      :type="bindViewType"
    ></Bind>
    <Login @onCloseClick="hideLogin" v-if="$store.state.isShowLogin"></Login>
  </div>
</template>

<script>
import { mapActions, mapMutations } from "vuex";
import AddDevice from "@/components/device/AddDevice.vue";
import NavV4 from "@/components/Common/NavV4.vue";
import NoBind from "@/components/HomeV4/NoBind.vue";
import Bind from "@/components/Node/Bind.vue";
import Login from "@/components/Login.vue";
import Menu from "@/components/Common/Menu.vue";
import PayExchange from "@/components/user/PayExchange.vue";
import Setting from "@/components/Node/Setting.vue";

export default {
  name: "Home",
  data: function () {
    return {
      isLoading: false,
      isShowNav: false,
      loadingGif: require("../assets/home/node/loading.gif"),
      logoSvgPath: require("../assets/home/logo.svg"),
      isShowDownloadAlert: false,
      isShowWyjTipsAlert: false,
      isShowHcTipsAlert: false,
      isShowByTipsAlert: false,
      isShowBindCheck: false,
      isShowBindLimitAlert: false,
      bindViewType: "bind",
      isShowAgree: false,
      isShowMenu: false,
      newPid: "",
      newPidT: "",
      newPidS: "",
      newPidInfo: {},
      bindSuccessTips: "设备绑定成功",
      isShowBindSuccess: false,
      bindFailedTips: "",
      isShowBindFailed: false,
      isGrabbing: false,
      lastGrabbingPositionX: 0,
      lastGrabbingPositionY: 0,
      navSpeedActiveFlag: false, //true小宝加速导航栏选中（路由中含有speed字符串即为选中）
      navNodeActiveFlag: false,
      pidInfo: {},
      list: [],
    };
  },
  components: {
    NavV4,
    NoBind,
    Login,
    Menu,
    PayExchange,
    AddDevice,
    Setting,
    Bind,
  },
  watch: {
    $route(to, from) {
      let _that = this;
      _that.initNav();
    },
    newPid: function (newVal) {
      let _that = this;
      _that.newPidInfo = _that.$common.getInfoByPid(newVal);
      if (_that.$route.query.hostname) {
        _that.newPidInfo.name = decodeURIComponent(_that.$route.query.hostname);
      } else {
        _that.newPidInfo.name = "";
      }
    },
    "$route.query.pid": function () {
      this.checkBind();
    },
    "$store.state.user.uid": function () {
      if (this.$store.state.user.uid) {
        this.hideLogin();
      }
    },
    "$store.state.curDev": function (newVal) {
      if (newVal && newVal.peerid) {
        this.pidInfo = this.$common.getInfoByPid(newVal.peerid);
      } else {
        this.pidInfo = {};
      }
    },
  },
  methods: {
    ...mapActions([
      "nodeRegister",
      "updateLocalApiHost",
      "getSysInfo",
      "bindget",
      "nodelist",
      "nodelistset",
      "scan",
      "scanlist",
      "vipLeft",
      "sendUserlog",
      "getAgree",
      "setAgree",
      "login",
      "checkBindList",
    ]),
    ...mapMutations(["setUser", "setClient"]),
    getBindget: function () {
      // console.log("getBindget");
      let _that = this;
      //用户是否有绑定设备
      _that.checkBindList([
        false,
        function (err, terms) {
          if (terms && terms.length > 0) {
            _that.$store.state.bind_list = terms;
            _that.list = terms;
            for (let index = 0; index < _that.list.length; index++) {
              const element = _that.list[index];
              element.ip_str = _that.$common.ipConvert(element.ip);
              if (
                element.term &&
                element.term.nic &&
                element.term.nic.length > 0 &&
                !element.term.status
              ) {
                for (let j = 0; j < element.term.nic.length; j++) {
                  const nic = element.term.nic[j];
                  let ip_str = _that.$common.ipConvert(nic.ipv4n);
                  // console.log(element.peerid, ip_str);
                  _that.$common.addTunxx(
                    element.peerid,
                    ip_str,
                    24,
                    _that.sendUserlog
                  );
                }
              }
            }
            // _that.$common.startTunxx(_that.sendUserlog);
          }
        },
      ]);
    },
    hideClientClick: function () {
      let _that = this;
      if (_that.$store.state.client == "windows") {
        window.external.miniWindow && window.external.miniWindow();
      } else if (_that.$store.state.client == "mac") {
        window.webkit.messageHandlers.miniWindow &&
          window.webkit.messageHandlers.miniWindow.postMessage({});
      }
    },
    closeClientClick: function () {
      let _that = this;
      if (_that.$store.state.client == "windows") {
        window.external.closeWindow && window.external.closeWindow();
      } else if (_that.$store.state.client == "mac") {
        window.webkit.messageHandlers.closeWindow &&
          window.webkit.messageHandlers.closeWindow.postMessage({});
      }
    },
    goXbyz: function () {
      let _that = this;
      if (!_that.$store.state.user.uid) {
        _that.showLogin();
        return;
      }
      _that.$router.push({
        name: "SpeedShare",
        params: { cur_pid: _that.$store.state.curDev.peerid },
      });
    },
    closeAddDeviceClick: function () {
      let _that = this;
      _that.$store.state.isShowAddDevice = false;
    },
    initNav: function () {
      let route = this.$route;
      let nav = this.$refs.nav;
      if (route.meta.isShowNav) {
        this.isShowNav = true;
      } else {
        this.isShowNav = false;
      }
      if (route.meta.navType) {
        nav.changeType(route.meta.navType);
      }
    },
    hidePayExchange: function () {
      this.$store.state.isShowPayExchange = false;
    },
    showLogin: function () {
      this.$store.state.isShowLogin = true;
    },
    hideLogin: function () {
      this.$store.state.isShowLogin = false;
    },
    onLogoClick: function () {
      this.$router.push("/home/node");
    },
    onSloganClick: function () {
      // this.$router.push("/home/desc");
      this.onLogoClick();
    },
    showMenu: function () {
      this.isShowMenu = true;
    },
    hideMenu: function () {
      // console.log("hideMenu");
      this.isShowMenu = false;
    },
    onTabClick: function (tabType) {
      let _that = this;
      _that.sendUserlog([tabType + "_click", ""]);
    },

    onHeaderGrabbing: function (e) {
      let _that = this;
      if (
        _that.$store.state.client == "windows" ||
        _that.$store.state.client == "mac"
      ) {
        if (_that.isGrabbing) {
          let x = e.screenX - _that.lastGrabbingPositionX;
          let y = e.screenY - _that.lastGrabbingPositionY;

          if (_that.$store.state.client == "windows") {
            window.external.moveWindow && window.external.moveWindow(x, y);
          } else if (_that.$store.state.client == "mac") {
            window.webkit.messageHandlers.moveWindow &&
              window.webkit.messageHandlers.moveWindow.postMessage({
                x: x,
                y: y,
              });
          }

          _that.lastGrabbingPositionX = e.screenX;
          _that.lastGrabbingPositionY = e.screenY;
        }
      }
    },
    onHeaderMouseUp: function (e) {
      let _that = this;
      if (
        _that.$store.state.client == "windows" ||
        _that.$store.state.client == "mac"
      ) {
        _that.isGrabbing = false;
        _that.lastGrabbingPositionX = 0;
        _that.lastGrabbingPositionY = 0;
        document.querySelector("body").style.cursor = "default";
      }
    },
    onHeaderMouseDown: function (e) {
      let _that = this;
      if (
        _that.$store.state.client == "windows" ||
        _that.$store.state.client == "mac"
      ) {
        _that.isGrabbing = true;
        _that.lastGrabbingPositionX = e.screenX;
        _that.lastGrabbingPositionY = e.screenY;
        document.querySelector("body").style.cursor = "grabbing";
      }
    },

    doBind: function () {
      let _that = this;
      _that.hideBindCheck();
      _that.bindPid(_that.newPid, _that.newPidT, _that.newPidS);
    },
    hideBindCheck: function () {
      let _that = this;
      history.pushState(
        "",
        "",
        window.document.location.origin + window.document.location.pathname
      );
      _that.isShowBindCheck = false;
    },
    showBindCheck: function () {
      let _that = this;
      if (!_that.$store.state.user.uid) {
        _that.showLogin();
      } else {
        _that.hideLogin();
      }
      _that.isShowBindCheck = true;
    },

    checkShowBind: function () {
      let _that = this;
      _that.bindget([
        function (err, data) {
          if (data.terms) {
            let isBind = false;
            for (let i = 0; i < data.terms.length; i++) {
              if (data.terms[i].peerid == _that.newPid) {
                isBind = true;
                break;
              }
            }
            if (!isBind) {
              _that.showBindCheck();
            } else {
              history.pushState(
                "",
                "",
                window.document.location.origin +
                  window.document.location.pathname
              );
            }
          } else {
            _that.showBindCheck();
          }
        },
      ]);
    },

    checkBind: function () {
      let _that = this;
      if (_that.$route.query.pid) {
        _that.newPid = _that.$route.query.pid;
        _that.newPidT = _that.$route.query.t;
        _that.newPidS = _that.$route.query.s;
        _that.checkShowBind();
      } else if (_that.$route.query.host) {
        _that.updateLocalApiHost([
          _that.$route.query.host,
          function () {
            _that.getSysInfo([
              function (err, data) {
                // console.log(data);
                _that.newPid = data.pid;
                if (!err && _that.newPid) {
                  _that.checkShowBind();
                }
              },
            ]);
          },
        ]);
      }
    },

    bindPid: function (localPid, t, s) {
      let _that = this;
      _that.isLoading = true;
      _that.nodeRegister([
        localPid,
        t,
        s,
        function (err, data) {
          // for test
          // data.rtn = 0;
          _that.sendUserlog(["bind", JSON.stringify(data)]);
          if (!err && data.rtn == 0) {
            _that.isLoading = false;
            _that.sendUserlog(["bindDevice_s", localPid]);
            _that.isShowBindCheck = true;
            _that.bindViewType = "success";
            history.pushState(
              "",
              "",
              window.document.location.origin +
                window.document.location.pathname
            );
            // 取消首次自动添加设备
            // _that.doAutoScanAfterBind(localPid);
            setTimeout(function () {
              window.location.reload();
            }, 3000);
          } else if (!err && data.rtn == 10112) {
            _that.sendUserlog(["bindDevice_f_other", localPid + "|10112"]);
            _that.bindget([
              function (err, data) {
                _that.isLoading = false;
                if (data.terms) {
                  let isBind = false;
                  for (let i = 0; i < data.terms.length; i++) {
                    if (data.terms[i].peerid == localPid) {
                      isBind = true;
                      break;
                    }
                  }
                  if (!isBind) {
                    _that.bindFailedTips = "该设备已被他人绑定";
                    _that.bindViewType = "failed";
                    _that.isShowBindCheck = true;
                  }
                } else {
                  _that.bindFailedTips = "该设备已被他人绑定";
                  _that.bindViewType = "failed";
                  _that.isShowBindCheck = true;
                }
                history.pushState(
                  "",
                  "",
                  window.document.location.origin +
                    window.document.location.pathname
                );
              },
            ]);
          } else if (!err && data.rtn == 10216) {
            _that.sendUserlog(["bindDevice_f_limit", localPid + "|10216"]);
            _that.isLoading = false;
            _that.showBindLimitAlert();
          } else {
            _that.sendUserlog(["bindDevice_f", localPid + "|" + data.rtn]);
            _that.isLoading = false;
            _that.bindFailedTips = "错误码：" + data.rtn;
            if (data.rtn == 311) {
              _that.bindFailedTips = "设备离线";
            }
            _that.bindViewType = "failed";
            _that.isShowBindCheck = true;
          }
        },
      ]);
    },

    goUserInfoClick: function () {
      let _that = this;
      if (_that.$store.getters.isAppstoreMode) {
        _that.showMenu();
        return;
      }
      _that.onTabClick("setting");
      _that.$router.push({ path: "/home/userinfo" });
    },

    getVipLeft: function () {
      let _that = this;
      _that.vipLeft([function () {}]);
    },

    // getBindget: function () {
    //   let _that = this;
    //   //用户是否有绑定设备
    //   _that.bindget([
    //     function (err, data) {
    //       if (data && !data.rtn) {
    //         //rtn等于0时，后台不返回此字段
    //         if (data && data.terms && data.terms.length > 0) {
    //           _that.$store.state.bind_list = data.terms;
    //         }
    //       }
    //     },
    //   ]);
    // },
    checkCode: function () {
      let _that = this;
      let code = _that.$route.query.code;
      if (code) {
        _that.login([
          code,
          function (err, data) {
            // console.log("login", data);
            if (data && data.rtn == 0) {
              data.data.headimgurl = data.data.headimgurl
                ? data.data.headimgurl
                : "";
              data.data.nick = data.data.nick ? data.data.nick : "";
              _that.$common.localStorage.setItem("jdxb-uid", data.data.uid);
              _that.$common.localStorage.setItem(
                "jdxb-openid",
                data.data.openid
              );
              _that.$common.localStorage.setItem("jdxb-name", data.data.nick);
              _that.$common.localStorage.setItem(
                "jdxb-avatar",
                data.data.headimgurl
              );
              _that.$common.localStorage.setItem(
                "jdxb-owcode",
                data.data.owcode
              );
              _that.$common.localStorage.setItem("jdxb-rkey", data.data.rkey);
              if (data.data.phone) {
                _that.$common.localStorage.setItem(
                  "jdxb-phone",
                  data.data.phone
                );
              }

              _that.setUser();

              //没有返回手机号则需要去绑定
              // if (!data.data.phone) {
              // 	_that.loginBindAvatar = data.data.headimgurl;
              // 	_that.loginBindName = data.data.nick;
              // 	_that.loginBindFlag = true;
              // 	_that.$common.localStorage.setItem(
              // 		"jdxb-login-bind-flag",
              // 		"1"
              // 	); //1需要去绑定
              // } else {
              // 	_that.$router.push({
              // 		path: "/",
              // 		query: _that.$route.query,
              // 	});
              // }

              // 不校验绑定手机，直接跳转主页
              _that.$router.push({
                path: "/",
                query: _that.$route.query,
              });
            }
            _that.sendUserlog(["login", JSON.stringify(data)]);
            _that.getVipLeft();
            _that.getBindget();
          },
        ]);
      }
    },
  },
  mounted() {
    let _that = this;
    _that.getVipLeft();
    _that.checkBind();
    _that.getBindget();
    _that.checkCode();
    _that.initNav();
  },
  beforeMount() {
    let _that = this;
    _that.setUser();
  },
};
</script>

<style lang="less" scoped>
.home.home-windows {
  user-select: none;
}
.home {
  position: relative;
  width: 980px;
  min-width: 980px;
  height: 615px;
  box-sizing: border-box;
  background-color: #544ad9;
  background-image: linear-gradient(190deg, #544ad9 0%, #191e9f 100%);
  border-radius: 4px;
  overflow: hidden;

  .header {
    width: 100%;
    height: 54px;
    box-sizing: border-box;
    .logo-windows {
      cursor: grab;
    }
    .logo.logo-mac {
      margin-top: 20px;
      margin-left: 6px;
    }
    .logo {
      height: 30px;
      line-height: 30px;
      margin-left: 10px;
      margin-top: 12px;
      float: left;
      cursor: pointer;

      .logo-bd {
        margin-right: 14px;
        width: 120px;
        height: 30px;
        vertical-align: middle;
        margin-top: -3px;
      }
      .logo-bd:hover {
        cursor: pointer;
        opacity: 0.9;
      }
      .slogan {
        margin-top: 4px;
        font-size: 14px;
        color: #dcf0fd;
        vertical-align: middle;
        cursor: pointer;
      }
      .slogan:hover {
        cursor: pointer;
        opacity: 0.9;
      }
    }

    .menu {
      margin-right: 25px;
      cursor: pointer;
      float: right;
      position: relative;
      margin-top: 17px;
      width: 20px;
      height: 20px;
      background-image: url("../assets/common/menu/menu.svg");
      background-size: 100% 100%;
    }

    .menu_line {
      margin-right: 20px;
      margin-top: 11px;
      float: right;
      position: relative;
      width: 1px;
      height: 30px;
      background-image: url("../assets/common/menu/menu_line.svg");
      background-size: 100% 100%;
    }

    .xbyz {
      float: right;
      margin-right: 15px;
      margin-left: -10px;
      margin-top: 14px;
      width: 37px;
      height: 33px;
      background-image: url("../assets/home/xbyz.png");
      background-size: 100% 100%;
    }

    .xbyz:hover {
      cursor: pointer;
      opacity: 0.9;
    }

    .unlogin {
      margin-right: 10px;
      cursor: pointer;
      float: right;
      position: relative;
      margin-top: 10px;
      padding-right: 12px;
      .unlogin-icon {
        width: 38px;
        height: 38px;
      }
      .unlogin-tips {
        position: absolute;
        top: -5px;
        right: 0;
        width: 44px;
        height: 23px;
      }
    }

    .user {
      margin-right: 20px;
      cursor: pointer;
      float: right;
      position: relative;
      margin-top: 10px;

      .free-icon {
        position: absolute;
        bottom: -4px;
        left: -3px;
        width: 37px;
        height: 10px;
        box-sizing: border-box;
        border: 1px solid #e5e5e5;
        background-color: rgba(232, 245, 254, 0.6);
        border-radius: 31px;

        div {
          position: absolute;
          top: -5px;
          left: -6px;
          color: #f5f5f5;
          font-size: 12px;
          transform: scale(0.6);
          white-space: nowrap;
        }
      }

      .vip-icon {
        position: absolute;
        bottom: -4px;
        left: -7px;
        width: 44px;
        height: 14px;
        img {
          width: 44px;
          height: 14px;
        }
      }

      .user_icon {
        display: inline-block;
        vertical-align: top;
      }

      .user_info {
        display: inline-block;
        vertical-align: top;
      }

      img {
        margin-right: 10px;
        width: 31px;
        height: 31px;
        border-radius: 31px;
      }

      .username {
        color: #f4f4f4;
        font-weight: bold;
        font-size: 12px;
        margin-top: 1px;
      }

      .uid {
        color: #cccccc;
        font-size: 12px;
        transform: scale(0.75);
        margin-left: -6px;
        margin-top: -2px;
      }
    }

    .hide-icon,
    .close-icon {
      width: 20px;
      height: 20px;
      padding: 5px;
      cursor: pointer;
      float: right;
      margin-top: 12px;
    }
    .close-icon {
      margin-left: 20px;
      margin-right: 10px;
      cursor: pointer;
    }
  }

  .content {
    width: 956px;
    height: 544px;
    padding-top: 1px;
    margin: 0 auto;
    background-color: #f3f2fe;
    background-image: var(
      --unnamed,
      linear-gradient(174deg, #fefefe 0%, #f3f2fe 21.77%, #edf0ff 100%)
    );
    background-image: url(../assets/home/content-bg.png);
    background-size: 100% 100%;
    border-radius: 4px;

    .main {
      display: block;
      background-color: #ffffff;
      margin: 0 auto;
      margin-bottom: 10px;
      // margin-right: 10px;
      border-radius: 3px;
      overflow: hidden;
    }
    .main-nav {
      width: 932px;
      height: 444px;
    }
  }
}
</style>
